import { formatCurrency, formatCurrencyCompact, formatNumber } from "./format";

// TODO(format-utils): consolidate this with formatNumber / formatCurrency /
// formatCurrencyCompact / formatNumberSignificantDigits / YaaS's formatCompactNumber
// in a dedicated future pass — currently 5+ similar utilities scattered.

const ONE_MILLION = 1_000_000;
const TEN_MILLION = 10_000_000;

/** Threshold-based balance formatter. Never emits scientific notation. */
export function formatBalance(value: number): string {
    if (!Number.isFinite(value)) return "—";
    const abs = Math.abs(value);
    // 1,234.56
    if (abs < ONE_MILLION) return formatNumber(value);
    // 1,234,567 (no decimals)
    if (abs < TEN_MILLION) return formatNumber(value, { maximumFractionDigits: 0 });
    // 12.5M (strip the $ — caller adds it)
    return formatCurrencyCompact(value).replace(/^\$/, "");
}

/** Threshold-based earnings formatter. Currency-prefixed. */
export function formatEarnings(value: number): string {
    if (!Number.isFinite(value)) return "—";
    const abs = Math.abs(value);
    // $1,234.56
    if (abs < ONE_MILLION) return formatCurrency(value);
    // $1,234,567 (no decimals — formatCurrency takes (value, minDecimals, maxDecimals))
    if (abs < TEN_MILLION) return formatCurrency(value, 0, 0);
    // $12.5M
    return formatCurrencyCompact(value);
}
